module.exports = __webpack_public_path__ + "fonts/Montserrat-Regular.svg";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/Montserrat-Regular.svg
// module id = 930
// module chunks = 0 1 2 3 4 5